<template>
    <UiLinkListShuttleLinksList :blok="blok" :locations="limitedLocations" class="sf-shuttle-links-list" />
</template>

<script setup lang="ts">
// Storyblok block prop
import type { IShuttleLinkList } from '@nuxt-monorepo/ui/types/components/ShuttleLinkList';
import type { IShuttleLocationData } from '@nuxt-monorepo/ui/types/products/ShuttleProducts';

const { blok } = defineProps<{ blok: IShuttleLinkList }>();

// Inject locations (array of location objects)
const locations = inject('shuttleLocationsList', []) as IShuttleLocationData[];

// Process and limit links
const limitedLocations = computed(() => {
    const limit = Number(blok.linksLimit);
    const hasLimit = Number.isFinite(limit) && limit > 0;
    const filtered = locations.filter((l) => l && l.active);
    return hasLimit ? filtered.slice(0, limit) : filtered;
});
</script>

<style scoped>
.sf-shuttle-links-list.shuttle-links-list {
    :deep(.title) {
        @apply text-primary;
    }
}
</style>
